import { render, staticRenderFns } from "./AppLayoutDetran.vue?vue&type=template&id=7f6d75c8&scoped=true"
import script from "./AppLayoutDetran.vue?vue&type=script&lang=js"
export * from "./AppLayoutDetran.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutDetran.vue?vue&type=style&index=0&id=7f6d75c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6d75c8",
  null
  
)

export default component.exports